import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVolumeOffFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-149.33 -348.44 1066.67 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M768 1184V96Q768 70 749.0 51.0Q730 32 704.0 32.0Q678 32 659 51L326 384H64Q38 384 19.0 403.0Q0 422 0 448V832Q0 858 19.0 877.0Q38 896 64 896H326L659 1229Q678 1248 704.0 1248.0Q730 1248 749.0 1229.0Q768 1210 768 1184Z"
	})
});
export default SvgVolumeOffFill;
